/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, type RequestExtraParams, request } from '@/utils/request'
import type {
  AdsPopupParticipatePostData,
  AdsPopupQueryPopupPostData,
  AdsPopupQueryPopupPostPayload,
  AdsPopupSavePopupLogPostData,
} from './data-contracts'

export type { ParamData, ReturnPromise } from '@/utils/request'

const baseUrl: string = '/sea_shell/leafy-seadragon'

/**
 * No description
 *
 * @tags AdsPopupApi
 * @name AdsPopupSavePopupLogPost
 * @summary 保存弹框日志
 * @request POST:/adsPopup/savePopupLog
 */
export function adsPopupSavePopupLogPost(
  root: {
    /** 页面类型 homePage,flightHomepage,hotelHomepage,trainHomepage */
    pageType?: string
    /** 配置ID */
    configId?: string
  },
  params: RequestExtraParams = {},
) {
  return request<AdsPopupSavePopupLogPostData, any>({
    url: baseUrl + `/adsPopup/savePopupLog`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags AdsPopupApi
 * @name AdsPopupParticipatePost
 * @summary 参与弹框活动
 * @request POST:/adsPopup/participate
 */
export function adsPopupParticipatePost(
  root: {
    /** 页面类型 homePage,flightHomepage,hotelHomepage,trainHomepage */
    pageType?: string
    /** 配置ID */
    configId?: string
  },
  params: RequestExtraParams = {},
) {
  return request<AdsPopupParticipatePostData, any>({
    url: baseUrl + `/adsPopup/participate`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * @description 只会出一个优先级最高的弹框
 *
 * @tags AdsPopupApi
 * @name AdsPopupQueryPopupPost
 * @summary 查询弹框
 * @request POST:/adsPopup/queryPopup
 */
export function adsPopupQueryPopupPost(root: AdsPopupQueryPopupPostPayload, params: RequestExtraParams = {}) {
  return request<AdsPopupQueryPopupPostData, any>({
    url: baseUrl + `/adsPopup/queryPopup`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}
